import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import { fullscreenStyled } from './lib/fullscreen-styled';

export const FullscreenButton = fullscreenStyled(OpenInFullIcon);
